import React from 'react';
import HeroSection from '../HeroSection';
import About from '../About';
import Cards from '../Cards';
import Testimonials from '../GoogleReview';
import Contact from '../Contact';

export default function Home() {
  return (
    <>
      <HeroSection />
      <About />
      <Cards />
      <Testimonials />
      <Contact />
    </>
  );
}
